export const NECK_SUB_ORGAN = [
  'nasal_pharynx',
  'oral_pharynx',
  'hypopharynx',
  'thyroid',
  'cervical_lymph_node_chain',
];

export const ORGAN_DISPLAY_NAMES = {
  bony_skeleton: 'Skeleton and soft tissues',
  gallbladder_and_biliary_system: 'Gallbladder',
  heart_and_great_vessels: 'Heart and vessels',
  lungs_and_mediastinum: 'Lungs',
  sinuses_and_mastoids: 'Sinuses',
};

export const NECK_ORGAN = 'neck';

export const NOT_AN_ORGAN = ['reason_for_scan', 'preview', 'key_images', 'final_impressions'];

export const SKU_WITHOUT_NECK_ORGAN = ['100'];

export const DEFAULT_EXPANDED_LINK_KEYS = ['neck'];

export const KEY_IMAGES_LINK = 'key_images';
